import { Discount } from '../types';

const DISCOUNT_KEY = 'cps_discount';

export const saveDiscount = (discount: Discount): void => {
  try {
    localStorage.setItem(DISCOUNT_KEY, JSON.stringify(discount));
  } catch (error) {
    console.error('Error saving discount:', error);
  }
};

export const loadDiscount = (): Discount | null => {
  try {
    const saved = localStorage.getItem(DISCOUNT_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch (error) {
    console.error('Error loading discount:', error);
    return null;
  }
};
